
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/franchisee/[slug]",
      function () {
        return require("private-next-pages/franchisee/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/franchisee/[slug]"])
      });
    }
  